import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Navbar from '../../../../_components/common/Navbar';
import SideNavBar from '../../../../_components/common/SideNavBar'
import { superAdminAreaData } from '../../OrgAdminArea/SidebarData'
import UtilityNav from '../../../../_components/common/UtilityNav'
import ModalComponent from '../../../../_components/common/Modal';
import { Table } from 'reactstrap';
import TableNew from '../../../../_components/common/Table';
import { Input } from 'reactstrap';
import { editSwotText } from './formData';
import { superAdminAction } from '../../../../_actions';

class SwotText extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            swotId: 1,
            editSwotModal: false,
            swotTextUpdateMessage: false,
            swotDetails: null,
            navData: [],
        }
    }

    componentDidUpdate(prevProp) {
        if(prevProp.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
    }

    componentDidMount() {
        this.props.dispatch(superAdminAction.getSwotTextHandler(this.state.swotId, () => { }))

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})
    }

    toggleeditSwotModal(showModal) {
        this.setState({
            editSwotModal: true,
            swotDetails: showModal
        })
    }

    toggleEntireSwotModal(showModal) {
        this.setState({
            editSwotModal: showModal
        })
    }

    actionSelected(data) {
        const swotDetails = this.state.swotDetails;
        const fd = {
            "text_data": data.data.text_data
        }
        this.props.dispatch(superAdminAction.editSwotTextHandler(swotDetails.id, swotDetails.swot_type, fd, () => {
            this.setState({ swotTextUpdateMessage: true })
        }))
    }

    onChangeSwot = (ev) => {
        this.setState({
            swotId: ev.target.value
        })
        this.props.dispatch(superAdminAction.getSwotTextHandler(ev.target.value, () => { }))
    }

    getHtmlTag(text) {
        let splitData = text.split(`\n`)
        const returnData =
            splitData.map(
                (data, i) => {
                    if (data.trim().charAt(0) === '-') {
                        return <li key={i}>{data.trim().substr(1)}</li>
                    }
                    else {
                        return < p key={i} className="mb-1"> {data}</p >
                    }
                }
            )
        return splitData.length > 1 ? returnData : splitData
    }

    getContent = (id) => {
        const { getSwotTextResponse } = this.props
        for (let i = 0; i < getSwotTextResponse.length; i++) {
            if (getSwotTextResponse[i].id === id) {
                return getSwotTextResponse[i].text_data
            }
        }
    }



    render() {
        const { getSwotTextResponse, getSwotTextLoading } = this.props;
        const tables = {
            data: [{
                name: 'Orientation',
                key: 'orientation__orientation_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                link: ''
            }, {
                name: 'Attribute',
                key: 'atribute__attribute_name',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: false,
                link: ''
            }, {
                name: 'Text',
                key: 'text_data',
                link: '',
                sort: false,
                type: 'text',
                content: '',
                alignCenter: false,
                headingAlign: true,
                link: ''
            }, {
                name: '',
                key: 'EDIT',
                link: '',
                sort: false,
                type: 'iconButton',
                content: 'fa fa-edit fa-custom',
                alignCenter: true,
                link: '',
                title: 'Edit'
            }]
        }

        let tableData = [];
        getSwotTextResponse !== '' &&
            getSwotTextResponse.map(
                (data, i) => {
                    tableData.push({
                        atribute__attribute_name: data.atribute__attribute_name,
                        atribute_id: data.atribute_id,
                        id: data.id,
                        orientation__orientation_name: data.orientation__orientation_name,
                        orientation_id: data.orientation_id,
                        swot_type: data.swot_type,
                        text_data: this.getHtmlTag(data.text_data),
                    })
                }
            )

        this.state.editSwotModal &&
            editSwotText.map(
                (data, i) => {
                    data.value = this.getContent(this.state.swotDetails.id);
                    data.valid = true;
                }
            )

        return (
            <div>
                <Navbar navItems={this.state.navData} backgroundColor="dark" />
                < div className="container-post-nav">
                    <SideNavBar sideNavItems={superAdminAreaData.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="main-body-div ">
                        <div className="d-flex flex-row justify-content-center mb-2">
                            <span className="col- my-1 h5" > SWOT Text &nbsp;
                                	{/* {
                                    loading &&
                                    <i className="fas fa-spinner fa-spin text-black spinner-position" ></i>
                                } */}
                            </span>
                            <Input
                                value={this.state.swotId}
                                type="select" name="field"
                                bsSize="sm" className="col-2 border-1"
                                onChange={this.onChangeSwot}
                            >
                                <option className="" value={1} key={0}>Strength</option>
                                <option className="" value={2} key={1}>Weakness</option>
                                <option className="" value={3} key={2}>Opportunity</option>
                                <option className="" value={4} key={3}>Threat </option>
                            </Input>
                        </div>
                        <TableNew
                            data={tableData}
                            columns={tables.data}
                            onClickEditIcon={this.toggleeditSwotModal.bind(this)}
                        />
                        {
                            getSwotTextLoading === true &&
                            <p className="text-center">
                                <i className="fas fa-spinner fa-spin text-dark " ></i>
                                &nbsp;loading
                            </p>
                        }
                        {
                            this.state.editSwotModal &&
                            <ModalComponent
                                showModal={this.state.editSwotModal}
                                heading="Swot Text"
                                formData={editSwotText}
                                action={this.actionSelected.bind(this)}
                                toggleEntireModal={this.toggleEntireSwotModal.bind(this)}
                                footerFormSubmitButton={['Save', 'Cancel']}
                                htmlText={`<div className = " mb-2  d-flex flex-row justify-content-center  col-12 ">
                                <div style="border: 1px solid grey" classname = "col-6 "><p className = "text-center my-2 ">${this.state.swotDetails.orientation__orientation_name}</p></div>  
                                <div style="border: 1px solid grey" classname = "col-6 "><p className = "text-center my-2 ">${this.state.swotDetails.atribute__attribute_name}</p></div></div>`}
                            />
                        }
                        {
                            this.state.swotTextUpdateMessage &&
                            <ModalComponent
                                showModal={this.state.swotTextUpdateMessage}
                                heading="Swot Text"
                                headingIcon="fa fa-check text-white"
                                toggleEntireModal={() => this.setState({ swotTextUpdateMessage: false })}
                                htmlText={`<div className = " text-center">
                                                <p className = "font-weight-bold">Success!</p>
                                                <p>Updated successfully.</p>
                                            </div>`}
                                footerNonSubmitButton={[{
                                    'buttonName': 'Close',
                                }]}
                                responseHandler={(type) => this.setState({ swotTextUpdateMessage: false })}
                            />
                        }
                    </div>
                </div>
            </div>
        )
    }
}



function mapStateToProps(state) {
    const { getSwotTextLoading } = state.getSwotTextReducer;
    const getSwotTextError = state.getSwotTextReducer.error;
    const getSwotTextResponse = (!getSwotTextLoading && !getSwotTextError) ? state.getSwotTextReducer.data.data.swot_text_list : ''

        //Header Permission
        const { headPerLoading } = state.headerPermissionReducer
        const headPerLoadingError = state.headerPermissionReducer.error
        const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';
    return {
        getSwotTextLoading,
        getSwotTextResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError
    }
}

export default connect(mapStateToProps)(SwotText);



// WEBPACK FOOTER //
// ./src/_pages/Organzation/SuperAdminArea/SwotText/index.js